import BaseEntityNew from 'client/components/core/BaseEntity/BaseEntityNew'
import ChildrenEntities from 'client/components/core/ChildrenEntities'
import EntityExampleWrapper from 'client/components/core/EntityExampleWrapper'
import { usePayment } from 'client/store'
import { getOfferBump } from 'client/store/payment/paymentSelectors'
import { EntityProps } from 'client/types'
import CommonOrderBump from 'common/components/entities/OrderBumpNew'
import { OrderBumpInterface } from 'common/types/entities/order-bump-interface'
import React from 'react'

function OrderBump({
  entity,
  isMoveDownAllowed,
  isMoveUpAllowed,
}: EntityProps<OrderBumpInterface>) {
  const bump = usePayment(getOfferBump)
  const { id, type, childIds, htmlAttrId, ...restProps } = entity

  const renderBump = () => (
    <CommonOrderBump {...restProps} attrId={htmlAttrId}>
      <ChildrenEntities id={id} childIds={childIds} type={type} />
    </CommonOrderBump>
  )

  return (
    <BaseEntityNew
      entity={entity}
      isMoveDownAllowed={isMoveDownAllowed}
      isMoveUpAllowed={isMoveUpAllowed}
    >
      {bump ? (
        renderBump()
      ) : (
        <EntityExampleWrapper label="entities.order_bump.warnings.no_price_plan">
          {renderBump()}
        </EntityExampleWrapper>
      )}
    </BaseEntityNew>
  )
}

export default OrderBump
